// extracted by mini-css-extract-plugin
export default {"container":"HydrateFallback_container__AV7cJ"};